import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/behance': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M232 237.2c43.6 12.3 64.7 45.2 64.7 89.7 0 72-60.5 102.9-124.9 102.9h-171.8v-354.4h167.1c60.7 0 113.3 17.2 113.3 87.8 0 35.8-16.6 58.8-48.4 74zM77.9 135.9v82.7h79c27.8 0 47.5-12.1 47.5-42.2 0-32.6-25.3-40.5-53.4-40.5h-73.1zM161.2 369.6c31.7 0 57.6-11.2 57.6-47 0-36.3-21.7-50.6-56-50.6h-84.9v97.6h83.3zM519.7 128.9h-143.7v-34.9h143.7v34.9zM576 305.2c0 4.5-0.3 9-0.6 13.2h-185.1c0 41.1 21.7 65.3 63 65.3 21.4 0 49-11.6 55.7-33.5h62.2c-19.1 58.7-58.8 86.3-120.1 86.3-81 0-131.3-54.8-131.3-134.7 0-77 53.1-135.8 131.3-135.8 80.5 0 124.9 63.3 124.9 139.2zM390.4 274h114.7c-3-34-20.8-54.8-56.2-54.8-33.8 0-56.2 21.1-58.5 54.8z'
      }
    ]
  }
})
